import { required, email } from 'vuelidate/lib/validators';
import { EFieldNames } from '@shared/models/Enums/EFieldNames';
import { FormFieldModel } from '@shared/models/LoginModels/FormFieldModel';

export interface ParentOrganizationLoginModel {
  [EFieldNames.Email]: string;
  [EFieldNames.Password]: string;
}

export const loginModel: ParentOrganizationLoginModel = {
  [EFieldNames.Email]: '',
  [EFieldNames.Password]: '',
};

export const loginFields: { [key: string]: FormFieldModel } = {
  [EFieldNames.Email]: {
    label: 'Email',
    icon: 'mdi-email-outline',
    errors: {
      required: 'Email is required',
      email: 'Email is not valid',
    },
  },
  [EFieldNames.Password]: {
    label: 'Password',
    icon: 'mdi-lock-outline',
    type: 'password',
    errors: {
      required: 'Password is required',
    },
  },
};

export const loginFieldsValidation = {
  [EFieldNames.Email]: {
    required,
    email,
  },
  [EFieldNames.Password]: {
    required,
  },
};
